import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function CtaBand({
  title = "Describe the outcome. We will trace the system.",
  copy = "Every engagement starts with a conversation about what you are observing — not with a proposal for technology.",
  testid = "cta-band",
}) {
  return (
    <section data-testid={testid} className="bg-navy text-white">
      <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 py-20 sm:py-28 lg:flex-row lg:items-end lg:justify-between">
        <Reveal>
          <p className="mb-6 font-mono text-[11px] tracking-[0.3em] text-slate-400">
            START THE CONVERSATION
          </p>
          <h2 className="max-w-2xl font-serif text-3xl leading-tight sm:text-4xl lg:text-5xl">
            {title}
          </h2>
          <p className="mt-6 max-w-xl leading-relaxed text-slate-300">{copy}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <Link
            to="/contact"
            data-testid="cta-band-discuss-button"
            className="group inline-flex items-center gap-2 border border-white/30 px-7 py-4 text-sm tracking-wide transition-colors duration-300 hover:bg-white hover:text-navy"
          >
            Discuss a System
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
